module.exports = __webpack_public_path__ + "img/mouse-fill.85cc570b.svg";